// extracted by mini-css-extract-plugin
export default {"container":"container-3tKaS","icon":"icon-3BBi4","label":"label-2UsB7","button":"button-2k1Kf"};